<template>
  <div>
    <el-dialog
        title="报送部门"
        :visible.sync="dialogVisible"
        width="90%"
        @close="close"
        top="4vh">
      <div
          :style="{
        height: scrollerHeight,
        overflow: 'auto',
      }"
      >
        <el-tree
            ref="treeRef"
            node-key="id"
            :data="TreeData"
            :props="props"
            show-checkbox
            @check="checkNode"
            :check-strictly="true"
            :default-expand-all="false"
            :default-checked-keys="defkeys"
            :default-expanded-keys="[1, Dept_ID]"
        >
         <span slot-scope="{ node }" class="custom-tree-node" >
          <span>
            <i class="el-icon-user-solid"></i>
            {{ node.label }}
          </span>
        </span>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
    </el-dialog>
  </div>

</template>

<script>
import {GetDeptTreeTable} from '@/api/common'
import {Toast} from "vant";

export default {
  name: "deptTree",
  data() {
    return {
      dialogVisible: false,
      TreeData: [],
      props: {
        label: 'name',
        id: 'id',
        IsDept: '',
        children: 'children',
      },
      defkeys: [],
      Staff_ID_Arr: [], //人事ID数组
      Staff_Name_Arr: [], //人事名称数组
      Dept_ID: 0,
      Dept_Name: '',
      initFlag: true
    }
  },
  computed: {
    scrollerHeight: function () {
      return window.innerHeight - 300 + 'px'
    },
  },
  methods: {
    //树形组件渲染
    async fetchData() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '正在加载...',
        forbidClick: true,
      });
      const {data} = await GetDeptTreeTable({})
      this.TreeData = data.data
      Toast.clear();
    },

    //树回绑  val当前Dept_Type  ID_Arr 选择的id数组
    showTree(val) {
      this.fetchData()
      this.dialogVisible = true
      this.Dept_ID = parseInt(val)
      if (this.$refs.treeRef !== undefined) {
        if (val !== 0)
          this.$refs.treeRef.setCheckedKeys([val]);
        else
          this.$refs.treeRef.setCheckedKeys([]);
      }
    },

    checkNode(node, obj) {

      if (obj.checkedKeys.length > 1) {

        try {
          obj.checkedKeys.forEach((item) => {
            if (this.Dept_ID !== item) {
              this.Dept_ID = node.id
              this.Dept_Name = node.name
              throw new Error()
            }
          })
        } catch (e) {
        }

        this.$refs.treeRef.setCheckedKeys([this.Dept_ID]);
      } else {
        this.Dept_ID = node.id
        this.Dept_Name = node.name
      }
    },

    //提交之后，推送id和name的 对象  父组件获取方法统一为getTree
    save() {
      let obj = null
      if (this.$refs.treeRef.getCheckedNodes().length !== 0) {
        obj = {
          Dept_ID: this.Dept_ID,
          Dept_Name: this.Dept_Name
        }
      }
      this.$emit('getTree', obj)
      this.close()
    },

    close() {
      this.dialogVisible = false
    },
  }
}
</script>

<style scoped>

</style>